<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="3" y="3.5" width="18" height="18" rx="5" stroke="#2A3243" stroke-width="2.5" stroke-linecap="round"
    stroke-linejoin="round" />
  <path
    d="M20.9084 16.4942L18.2071 13.7929C17.8165 13.4024 17.1834 13.4024 16.7928 13.7929L14.5 16.0858L10.2071 11.7929C9.81654 11.4024 9.18337 11.4024 8.79285 11.7929L3.3125 17.2732"
    stroke="#2A3243" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  <path
    d="M14.3232 8.82383L14.3236 8.82339C14.4211 8.72387 14.5808 8.72218 14.6804 8.81962C14.78 8.91705 14.7818 9.07675 14.6844 9.17639C14.587 9.27603 14.4273 9.27791 14.3276 9.1806C14.2279 9.08328 14.2259 8.92359 14.3232 8.82383"
    stroke="#2A3243" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
</svg>